<template>
  <div id="search">
    <!-- 搜索框 -->
    <div class="search-top">
      <div class="search-wrap">
        <div class="search-con">
          <SearchLoc @selectValue="getAddress"></SearchLoc>
          <input
            type="text"
            placeholder="搜职位、搜公司…"
            v-model="searchValue.name"
            class="search-input"
            @blur="jobName()"
          />
          <button class="search-btn">
            <img
              src="@/assets/img/search_white.png"
              alt=""
              class="search-icon"
            />搜索
          </button>
        </div>
      </div>
      <div class="search-condition">
        <div class="wrap">
          <ul class="search-filter">
            <li
              class="search-filter-item"
              v-for="(item, index) in speciesData"
              :key="index"
            >
              <p class="search-filter-tit">{{ item.value }}：</p>
              <ul class="search-filter-list">
                <!-- nature -->
                <li
                  class="search-filter-li"
                  v-for="sonitem in item.childList"
                  :key="sonitem.key"
                  :class="{
                    'search-filter-act': item.tabNum == sonitem.key,
                  }"
                  @click="
                    searchTab(sonitem.value, sonitem.key, item.tabNum, item.key)
                  "
                >
                  {{ sonitem.value }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 搜索框 -->
    <main class="main">
      <div class="wrap main-wrap">
        <article class="article" :class="{ white: !hasData }">
          <div class="search-tab">
            <p
              class="search-tab-son"
              v-for="item in tabData"
              :key="item.id"
              :class="{ 'search-tab-act': tabSortNum == item.id }"
              @click="sortData(item.id)"
            >
              {{ item.title }}
            </p>
          </div>
          <div class="search-result" v-if="hasData">
            <ul class="result-list-wrap">
              <li
                class="result-list"
                v-for="(item, index) in jobData"
                :key="index"
              >
                <div class="result-t">
                  <div
                    class="result-t-l"
                    @click="goJob(item.jobId, item.clientId)"
                  >
                    <p class="job-line">
                      <span class="blue jobname">{{ item.jobName }}</span>
                      <span class="blue jobcity">[{{ item.areaCodeStr }}]</span
                      ><span class="result-date"
                        >{{ item.createDateStr }}发布</span
                      >
                    </p>
                    <div class="result-money-wrap">
                      <span class="result-money">{{ item.salaryAreaStr }}</span>
                      <ul class="result-money-list">
                        <li>
                          <span class="division">|</span
                          >{{ item.recruitmentTypeStr }}
                        </li>
                        <li>
                          <span class="division">|</span
                          >{{ item.educationLevelIdStr }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="result-t-r" @click="goCompany(item.clientId)">
                    <div>
                      <p class="blue">
                        {{ item.clientName }}
                      </p>
                      <p class="resule-num">
                        {{ item.industryStr }}<span class="division">|</span
                        >{{ item.companyScaleIdStr }}
                      </p>
                    </div>
                    <div class="top-company-logo">
                      <img :src="item.logo" class="result-logo" alt="" />
                    </div>
                  </div>
                </div>
                <div class="result-b">
                  <ul class="result-b-list">
                    <li
                      class="result-b-li"
                      v-for="(sonitem, sonindex) in item.treatment"
                      :key="sonindex"
                    >
                      {{ sonitem }}
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <div class="fenye" v-if="isFenye">
              <a-pagination
                v-model="current"
                :total="jobDataTotal"
                :page-size="10"
                @change="onChange"
                show-less-items
              />
            </div>
          </div>
          <div class="search-result-null" v-else>
            <img src="@/assets/img/null.png" class="search-null-logo" alt="" />
            <p class="search-null-tit">暂无数据</p>
          </div>
        </article>
        <aside class="aside">
          <div class="index-tit-wrap">
            <div class="index-tit">热门企业</div>
            <div class="update-date" @click="updateDate">
              <img
                src="@/assets/img/update.png"
                class="update-icon"
                :class="{ 'update-icon-on': isUpdate }"
                alt=""
              />
              换一批
            </div>
          </div>
          <ul class="top-company">
            <li
              class="top-company-item"
              v-for="(item, index) in companyData"
              @click="goCompany(item.clientId)"
              :key="index"
            >
              <div class="top-company-logo">
                <img :src="item.logo" class="top-company-wrap" alt="" />
              </div>
              <div class="top-company-r">
                <p class="top-company-tit">{{ item.clientName }}</p>
                <p class="top-company-num">
                  <span>{{ item.jobCount }}</span> 个职位正在发布
                </p>
              </div>
            </li>
          </ul>
        </aside>
      </div>
    </main>
  </div>
</template>
<script>
import SearchLoc from "@/components/SearchLoc.vue";
import { getCategorizer, GetJobJobList, GetCompanyList } from "@/api/search.js";

export default {
  components: {
    SearchLoc,
  },
  data() {
    return {
      hasData: false,
      tabData: [
        {
          id: 0,
          title: "默认排序",
        },
        {
          id: 1,
          title: "薪资排序",
        },
      ],
      tabSortNum: 0,
      searchValue: {
        areaCode: "",
        name: "",
        recruitmentType: 0,
        educationLevelId: 0,
        companyNatureId: 0,
        industry: 0,
        sort: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      name: "",
      speciesData: [],
      jobData: [],
      jobDataTotal: 0,
      companyData: [],
      companyNow: 1,
      companyTotal: 0,
      companyEnd: 0,
      isUpdate: false,
      current: 1,
      isFenye: false,
    };
  },
  created() {
    this.searchValue.name = this.$route.query.name;
    this.getSpecies();
    this.GetJob();
    this.GetCompany(1, 6);
  },
  methods: {
    // 更改城市时提交
    getAddress(value) {
      if (value[0] == "00") {
        this.searchValue.areaCode = "00";
      } else {
        this.searchValue.areaCode = value[1];
      }
      this.GetJob();
    },
    // 输入职位名字等提交
    jobName() {
      this.GetJob();
    },
    // 排序
    sortData(id) {
      this.searchValue.sort = id;
      this.tabSortNum = id;
      this.GetJob();
    },
    // 点击tab的时候提交search
    searchTab(value, sonkey, tabNum, key) {
      // value 选中的值
      // sonkey 选中的下标
      // tabNum tab下标
      // key 哪一项
      this.speciesData[key].tabNum = sonkey;
      if (key == 0) {
        this.searchValue.recruitmentType = sonkey;
      } else if (key == 1) {
        this.searchValue.educationLevelId = sonkey;
      } else if (key == 2) {
        this.searchValue.companyNatureId = sonkey;
      } else if (key == 3) {
        this.searchValue.industry = sonkey;
      }
      this.GetJob();
    },
    searchSubmit() {},
    // 获取筛选列表
    getSpecies() {
      getCategorizer()
        .then((res) => {
          this.speciesData = res;
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // 获取职位
    GetJob() {
      let data = this.searchValue;
      GetJobJobList(data)
        .then((res) => {
          if (res.success) {
            if (res.data.length > 0) {
              this.hasData = true;
              this.jobData = res.data;
              this.jobDataTotal = res.totalCount;
              if (this.jobDataTotal > 10) {
                this.isFenye = true;
              }
            } else {
              this.hasData = false;
            }
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // // 获取侧栏公司
    GetCompany(pageIndex, pageSize) {
      let data = {
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
      GetCompanyList(data)
        .then((res) => {
          if (res.success) {
            this.companyData = res.data;
            this.companyTotal = Math.ceil(res.totalCount / 6);
            this.companyEnd = res.totalCount % 6;
            if (this.companyEnd == 0) {
              this.companyEnd = 6;
            }
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    goCompany(id) {
      this.$router.push({ path: "/company", query: { id } });
    },
    goJob(id, clientId) {
      this.$router.push({
        path: "/job",
        query: { id: id, clientId: clientId },
      });
    },
    // 换一批
    updateDate() {
      if (this.companyTotal != 1) {
        this.isUpdate = !this.isUpdate;
        // 换一批页码数加一
        this.companyNow = this.companyNow + 1;
        // 向下取整
        if (this.companyNow == this.companyTotal) {
          this.GetCompany(this.companyNow, this.companyEnd);
          this.companyNow = 0;
        } else {
          this.GetCompany(this.companyNow, 6);
        }
      } else {
        this.$message.warning("只有这么多数据了！");
      }
    },
    onChange(pageNumber) {
      this.searchValue.pageIndex = pageNumber;
      this.GetJob();
    },
  },
};
</script>
<style scoped>
#search {
  padding-top: 64px;
}
.wrap {
  width: 1200px;
  margin: 0 auto;
}
.search-top {
  background: #fff;
}
.search-wrap {
  padding: 30px 0;
  border-bottom: 1px solid #eee;
}
.search-condition {
  padding: 22px 0 2px;
}
.search-filter-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  padding-left: 55px;
}
.search-filter-li:first-child {
  position: absolute;
  left: 0;
  top: 0;
}
.search-filter-item {
  margin-bottom: 15px;
  position: relative;
  padding-left: 80px;
}
.search-filter-tit {
  font-weight: 500;
  margin-right: 10px;
  width: 80px;
  position: absolute;
  left: 0;
  top: 4px;
}
.search-filter-none,
.search-filter-li {
  padding: 5px 14px;
  cursor: pointer;
  margin-bottom: 5px;
}
.search-filter-act {
  background: #3b87ff;
  color: #fff;
  border-radius: 12px;
}
.main {
  background: #f5f5f5;
  padding-bottom: 40px;
}
.main-wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.aside {
  width: 300px;
  flex: 0 0 300px;
  margin-left: 20px;
}
.article {
  flex: 0 0 880px;
  display: flex;
  flex-direction: column;
}
.index-tit-wrap {
  display: flex;
  justify-content: space-between;
  background: #fff;
}
.update-date {
  height: 30px;
  display: flex;
  align-items: center;
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 14px;
  border: 1px solid #3b87ff;
  color: #3b87ff;
  cursor: pointer;
}
.update-icon {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  transition: all 0.3s ease-in;
}
.search-tab {
  height: 50px;
  line-height: 50px;
  padding: 0 24px;
  border-bottom: 1px solid #eee;
  display: flex;
  background: #fff;
}
.search-tab-son {
  margin-right: 46px;
  cursor: pointer;
}
.search-tab-act {
  position: relative;
  color: #3b87ff;
}
.search-tab-act::after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  content: "";
  height: 2px;
  background: #3b87ff;
}
.fenye {
  padding-top: 14px;
  text-align: center;
  background: #f5f5f5;
}
.search-result-null {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background: #fff;
  flex-direction: column;
}
.search-null-logo {
  width: 72px;
  height: 72px;
}
.search-null-tit {
  color: #999999;
  line-height: 20px;
  margin-top: 12px;
  width: 100%;
  text-align: center;
}
.result-b {
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  padding: 9px 22px;
  background: #f8f9fc;
  height: 40px;
  overflow: hidden;
  width: 100%;
}
.result-t {
  display: flex;
  padding: 16px 22px;
  justify-content: space-between;
  align-items: center;
}
.result-t-r {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.result-t-r .blue {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.result-money-wrap,
.result-money-list {
  display: flex;
}
.result-list-wrap {
  background: #f5f5f5;
}
.result-list {
  position: relative;
  margin-bottom: 14px;
  background: #fff;
  cursor: pointer;
}
.result-list:last-child {
  margin-bottom: 0;
}
.result-list:hover::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: "";
  z-index: 1;
  border: 1px solid #3b87ff;
}
.result-t-l,
.result-t-r {
  position: relative;
  z-index: 2;
}
.result-b-list {
  display: flex;
  flex-wrap: wrap;
  max-width: 830px;
  max-height: 22px;
  overflow: hidden;
}
.result-b-li {
  display: inline;
  height: 22px;
  line-height: 21px;
  padding: 0 5px;
  white-space: nowrap;
  margin-right: 10px;
  border-radius: 2px;
  border: 1px solid #cccccc;
}
.result-b-li:last-child {
  margin-right: 0;
}
.result-b-tit {
  color: #666;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.white {
  background: #fff;
}
.result-t-l {
  width: 60%;
}
.result-t-r,
.result-b-tit {
  width: 40%;
}
.job-line {
  display: flex;
  align-items: center;
}
.blue {
  font-size: 16px;
  color: #3b87ff;
  padding-right: 7px;
}
.jobname {
  display: inline-block;
  max-width: 270px;
  overflow: hidden;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.15;
}
.jobcity,
.result-date {
  display: inline-block;
  max-width: 110px;
  overflow: hidden;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.result-date {
  font-size: 14px;
  color: #999999;
}
.result-money-wrap,
.resule-num {
  margin-top: 16px;
}
.result-money {
  color: #ff6600;
  font-size: 16px;
}
.division {
  padding: 0 13px;
  color: #dddddd;
}
.result-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.index-tit-wrap {
  display: flex;
  height: 50px;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #eeee;
}
.index-tit {
  font-size: 16px;
}
.top-company {
  background: #fff;
}
.top-company-item {
  display: flex;
  padding: 16px 20px;
  border-bottom: 1px solid #eeee;
  cursor: pointer;
}
.top-company-item:hover {
  background: #f9f9f9;
}
.top-company-item:hover .top-company-tit {
  color: #3b87ff;
}
.top-company-logo {
  flex: 0 0 56px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #f5f5f5;
  margin-right: 14px;
  background: #fff;
}
.result-t-r .top-company-logo {
  margin: 0;
}
.top-company-wrap {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.top-company-r {
  padding: 5px 0;
}
.top-company-tit {
  font-size: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.top-company-num {
  color: #999999;
  margin-top: 12px;
}
.top-company-num span {
  color: #3b87ff;
}
.search-con {
  position: relative;
  width: 930px;
  height: 46px;
  display: flex;
  margin: 0 auto;
  border: 2px solid #3b87ff;
  align-items: center;
}
.search-input {
  flex: 1;
  height: 100%;
  padding: 0 14px;
  color: #333;
}
.search-con::before {
  content: "";
  position: absolute;
  left: 79px;
  top: 14px;
  background: #ddd;
  width: 2px;
  height: 15px;
}
::-webkit-input-placeholder {
  color: #999;
}

::-moz-placeholder {
  color: #999;
}

:-ms-input-placeholder {
  color: #999;
}
.search-btn {
  width: 120px;
  height: 46px;
  color: #fff;
  background: #3b87ff;
  appearance: none;
  border: none;
  font-size: 16px;
  transform: translateX(2px);
  cursor: pointer;
}
.search-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.update-icon-on {
  transform: rotate(360deg);
  transition: all 0.3s ease-in;
}
</style>
